// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__FDofT","content":"styles_content__H1RqV","projects":"styles_projects__8OG-s"};